import React from 'react';
import { Tooltip } from '@mui/material';
import type { KontrolaStatusResponse } from '../../../api/JsdhNotifikaceService/generated/models/Kontrola';

/** Text tooltipu bunky matice (spec 6.2), null = bez tooltipu. */
export const popisNahrazeni = (k: KontrolaStatusResponse): string | null => {
    if (!k.relevantni && k.nahrazenoTypy && k.nahrazenoTypy.length > 0) {
        return `Nahrazeno: ${k.nahrazenoTypy.map((t) => t.nazev).join(', ')}`;
    }
    if (k.relevantni && k.prevzatoZTypu) {
        return `Převzato z: ${k.prevzatoZTypu.nazev}`;
    }
    return null;
};

const KontrolaStavTooltip: React.FC<{ kontrola: KontrolaStatusResponse; children: React.ReactElement }> = ({
    kontrola,
    children,
}) => {
    const popis = popisNahrazeni(kontrola);
    if (!popis) {
        return children;
    }
    return <Tooltip title={popis} arrow>{children}</Tooltip>;
};

export default KontrolaStavTooltip;
